import { Divider } from "@cvpartner/design-system";
import { ChevronDown, ChevronUp } from "@cvpartner/design-system/icons/line";
import type * as React from "react";
import {
  MenuItem,
  Menu as ReactAriaMenu,
  type SeparatorProps,
} from "react-aria-components";
import {
  anchor,
  anchorText,
  chevron,
  icon,
  link,
  menuWrapper,
  popover,
} from "./MenuNav.css.ts";

export const NavLink: React.FC<{
  href: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  text: string;
  onAction?: () => void;
}> = ({ href, icon: Icon, text, onAction }) => (
  <MenuItem href={href} className={link} onAction={onAction}>
    {({ isHovered, isFocused }) => (
      <div className={anchor({ isHovered: isHovered || isFocused })}>
        <Icon className={icon} />
        <span className={anchorText}>{text}</span>
      </div>
    )}
  </MenuItem>
);

export const Menu: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ReactAriaMenu className={popover}>{children}</ReactAriaMenu>
);

export const Separator: React.FC<{
  orientation?: SeparatorProps["orientation"];
}> = ({ orientation }) => <Divider variant="thin" orientation={orientation} />;

export const Chevrons: React.FC<{ isHovered: boolean; isOpen: boolean }> = ({
  isHovered,
  isOpen,
}) =>
  isOpen ? (
    <ChevronUp className={chevron({ isHovered, active: true })} />
  ) : (
    <ChevronDown className={chevron({ isHovered })} />
  );

export const MenuWrapper: React.FC<{
  isOpen: boolean;
  open: () => void;
  children: React.ReactNode;
}> = ({ isOpen, open, children }) => (
  <div className={menuWrapper} onClickCapture={isOpen ? undefined : open}>
    {children}
  </div>
);
